import {
    Group, Texture, RepeatWrapping, sRGBEncoding,
} from 'three';
import { ArrowModel } from './ArrowModelInterface';

export class OrdermadeArrowModel implements ArrowModel {
    private arrow: Group;

    public constructor(model: Group) {
        this.arrow = model;
    }

    get model(): Group {
        return this.arrow;
    }

    protected static applyTextureParamWithShaft(tex: Texture): void {
        tex.wrapS = RepeatWrapping;
        tex.wrapT = RepeatWrapping;
        tex.repeat.x = 1;
        tex.repeat.y = 5;
        tex.encoding = sRGBEncoding;
    }

    protected static applyTextureParam1(tex: Texture): void {
        tex.wrapS = RepeatWrapping;
        tex.wrapT = RepeatWrapping;
        tex.repeat.x = 1;
        tex.repeat.y = 1;
        tex.encoding = sRGBEncoding;
    }
}
